/**
 * Composes folder-tree runtime handlers (rename, sort, creatable) into `FolderTreeRuntimeContext`.
 */ import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo } from "react";
import { useFolderTreeRuntimeProvider } from "./folderTreeRuntime.js";
import { useTreeCreatableHandlers } from "../hooks/creatable/useTreeCreatableHandlers.js";
import { useTreeRenameModeHandlers } from "../hooks/modes/useTreeRenameModeHandlers.js";
import { useTreeSortModeHandlers } from "../hooks/modes/useTreeSortModeHandlers.js";
import { bindFolderTreeCreatableSerialMode } from "../util/folderTreeCreatableSerial.js";
function FolderTreeRuntimeProvider({ children }) {
    const renameHandlers = useTreeRenameModeHandlers();
    const sortHandlers = useTreeSortModeHandlers();
    const creatableHandlers = useTreeCreatableHandlers();
    const resolveBuiltInToolbarAction = useCallback((action, buttonId)=>({
            ...renameHandlers?.resolveBuiltInToolbarAction?.(action, buttonId) ?? {},
            ...sortHandlers?.resolveBuiltInToolbarAction?.(action, buttonId) ?? {}
        }), [
        renameHandlers,
        sortHandlers
    ]);
    const runtimeValue = useMemo(()=>({
            ...renameHandlers,
            ...sortHandlers,
            ...creatableHandlers,
            resolveBuiltInToolbarAction
        }), [
        creatableHandlers,
        renameHandlers,
        resolveBuiltInToolbarAction,
        sortHandlers
    ]);
    const [FolderTreeRuntimeProviderContext, runtimeContextValue] = useFolderTreeRuntimeProvider(runtimeValue);
    useEffect(()=>{
        if (!creatableHandlers) {
            return undefined;
        }
        return bindFolderTreeCreatableSerialMode();
    }, [
        creatableHandlers
    ]);
    return /*#__PURE__*/ _jsx(FolderTreeRuntimeProviderContext, {
        value: runtimeContextValue,
        children: children
    });
}
export { FolderTreeRuntimeProvider };
